import { storage } from '@visiba/std';
import type { Settings } from '../features/settings/user_settings.service';
import type { BookingSettingsRaw } from '../views/view_booking/hooks/use_booking_settings';
import type { CreateNewMessageSettings } from '../views/view_create_new_message/hooks/use-create-new-message-settings';

export const applicationLocalStorage = storage<{
	USER_SETTINGS: Settings;
	webVersion: string;
	createNewMessageSettings: Record<number, CreateNewMessageSettings>;
	bookingSettings: Record<number, BookingSettingsRaw>;
	'shell-variant': 'shell' | 'shell-2' | 'shell-3';
	cookieConsentRevision: {
		version: number;
		timestamp: string;
		consent: number;
	};
}>({ type: 'local' });
